import { render, staticRenderFns } from "./TemplateEditorActions.vue?vue&type=template&id=392d2fa8&scoped=true"
import script from "./TemplateEditorActions.vue?vue&type=script&lang=ts"
export * from "./TemplateEditorActions.vue?vue&type=script&lang=ts"
import style0 from "./TemplateEditorActions.vue?vue&type=style&index=0&id=392d2fa8&prod&scoped=true&lang=css"
import style1 from "./TemplateEditorActions.vue?vue&type=style&index=1&id=392d2fa8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392d2fa8",
  null
  
)

export default component.exports